<template>
    <c-dialog ref="dialog" title="售后工单详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.order_number" class="m-detail-tag flex-center-cross">
                <label>{{detailData.order_number}}</label>
                <c-state dict="afterSaleOrderStateDic" tag :value="detailData.status"></c-state>
                <c-state v-if="detailData.urgency_level != 1" dict="urgencyLevelDic" tag :value="detailData.urgency_level"></c-state>
                <c-state v-if="detailData.is_delayed == 1" tag color="red">
                    逾期<span v-if="detailData.delayed_days > 0">{{detailData.delayed_days}}天</span>
                </c-state>
            </div>
        </template>

        <module>
            <module-col size="400">
                <c-detail class="m-detail-form">
                    <c-detail-item label="客户名称">
                        {{detailData.customer_name}}
                    </c-detail-item>
                    <c-detail-item label="售后申请单">
                        <c-link v-if="auth('b_aftersale_apply_view')" @click="globalDialog('aftersaleApplyDetail', {props: {id: detailData.apply_id}})">{{detailData.apply_order_code}}</c-link>
                        <span v-else> {{detailData.apply_order_code}}</span>
                    </c-detail-item>
                    <c-detail-item label="意见处理单号">
                        {{detailData.complaint_no}}
                    </c-detail-item>
                    <c-detail-item label="服务类型">
                        <c-state dict="serviceTypeDic"  :value="detailData.service_type"></c-state>
                    </c-detail-item>
                    <c-detail-item label="售后类别">
                        <c-state dict="afterSaleTypeDic"  :value="detailData.aftersale_type"></c-state>
                    </c-detail-item>
                    <c-detail-item label="预估收费金额" v-if="auth('b_aftersale_apply_view')">
                        ￥{{detailData.estimated_fee}}
                    </c-detail-item>
                    <c-detail-item label="预估总成本" v-if="auth('b_aftersale_order_edit')||auth('b_aftersale_order_cost_detail')">
                        ￥{{detailData.estimated_cost_total}}
                        <c-link v-if="
                        auth('b_aftersale_order_cost_detail')
                        && detailData.estimated_cost_total
                        && detailData.estimated_cost_total > 0
                        && detailData.estimated_cost_json" @click="showEstimatedCost()">成本明细</c-link>
                    </c-detail-item>
                    <c-detail-item label="客户服务地址">
                        {{detailData.customer_address}}
                    </c-detail-item>
                    <c-detail-item label="售后网点">
                        {{detailData.after_sale_outlet_name}}
                    </c-detail-item>
                    <c-detail-item label="公里数">
                        {{detailData.customer_distance}}km
                        <span v-if="detailData.customer_duration > 0">
                            <label>（驾车预计耗时：{{detailData.customer_duration}}小时）</label>
                        </span>
                    </c-detail-item>
                    <c-detail-item label="预约时间">
                        <b>{{detailData.appointment_start_time}}</b> ~ <b>{{detailData.appointment_end_time}}</b>
                    </c-detail-item>
                    <c-detail-item label="预计服务时长">
                        {{detailData.estimated_service_days}}天{{detailData.accommodation_days}}夜
                    </c-detail-item>
                    <c-detail-item label="出行方式">
                        <c-state dict="travelModeOptions" :value="detailData.travel_mode"></c-state>
                    </c-detail-item>
                    <c-detail-item label="是否使用机台">
                        <c-state dict="useMachineOptions" :value="detailData.use_machine"></c-state>
                    </c-detail-item>

                    <c-detail-item label="负责人">
                        {{detailData.charge_user_realname}}
                        <c-link v-if="auth('b_aftersale_order_dispatch_log') && (detailData.dispatch_id || detailData.dispatch_method)" @click="globalDialog('afterSaleOrderDispatchLog', {props: {id: detailData.id}})">派单日志</c-link>
                    </c-detail-item>
                    <c-detail-item label="参与人">
                        {{detailData.group_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="业务员姓名">
                        {{detailData.salesman_name}}
                    </c-detail-item>
                    <c-detail-item label="业务员电话">
                        {{detailData.salesman_phone}}
                    </c-detail-item>
                    <c-detail-item label="现场图">
                        <c-file-list :value="detailData.scene_images" size="mini"></c-file-list>
                    </c-detail-item>
                    <c-detail-item label="需求描述">
                        {{detailData.demand_description}}
                    </c-detail-item>
                    <c-detail-item label="必备技能">
                        {{detailData.require_skills}}
                    </c-detail-item>
                    <c-detail-item label="星级要求">
                        <c-state dict="starLevelDic" :value="detailData.require_star_level"></c-state>
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{detailData.create_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <custom-detail ref="customDetail" work-type="3" :data="detailData.custom_fields_value_json"></custom-detail>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="售后服务明细" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="productListTable" :data="productList" border :paging="false">
                            <c-table-column label="存货编码" width="100">
                                <template #default="{data}">
                                    <span>{{data.inventory_code||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="存货名称" width="120">
                                <template #default="{data}">
                                    <span>{{data.inventory_name||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="规格型号" width="120">
                                <template #default="{data}">
                                    <span>{{data.spec_model||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="长(mm)" width="80">
                                <template #default="{data}">
                                    <span>{{data.length||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="宽(mm)" width="80">
                                <template #default="{data}">
                                    <span>{{data.width||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="数量" width="80">
                                <template #default="{data}">
                                    <span>{{data.quantity||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="件数" width="80">
                                <template #default="{data}">
                                    <span>{{data.pieces||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="环接方式" width="100">
                                <template #default="{data}">
                                    <span>{{data.connection_method||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="备注" width="150">
                                <template #default="{data}">
                                    <span>{{data.item_remark||'-'}}</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
                <!--跟进记录-->
                <module-tab name="跟进记录" enable-flex>
                    <c-tab-list ref="logTab" :tabs="logTabList" type="card" :immediate="false" @change="logTabHandle"></c-tab-list>
                    <c-scroll-list ref="logList" class="flex-grow" page-size="25">
                        <template #default="{data, index}">
                            <log-item
                                :key="index"
                                :date="data.create_date"
                                :person="data.create_user_realname"
                                :action="data.remark"
                                :order_id="data.order_id"
                                :dispatch_id="data.dispatch_id"
                            >
                                <template v-if="data.is_anomaly == 2" #tag>
                                    <c-state tag hollow color="#FFAE00" style="border-radius: .08rem; padding: 0 .08rem;">异常打卡</c-state>
                                </template>
                                <template v-if="data.data_list.length" #remark>
                                    <c-field v-for="(item, i) in data.data_list" :key="i" :label="item.label">{{item.content}}</c-field>
                                </template>
                                <template v-if="data.img_list" #image>
                                    <c-file-list :value="data.img_list" size="mini"></c-file-list>
                                </template>
                            </log-item>
                        </template>
                    </c-scroll-list>
                </module-tab>
                <!--成员列表-->
                <module-tab :name="memberListTitle" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="memberListTable" :data="memberList" border :paging="false">

                            <c-table-column label="成员头像" width="60">
                                <template #default="{data}">
                                    <c-file v-if="data.head_photo" class="img" :src="data.head_photo" media style="width:30px;height:30px;"></c-file>
                                </template>
                            </c-table-column>

                            <c-table-column label="成员姓名" width="120">
                                <template #default="{data}">
                                    <span>{{data.user_realname}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="负责人" width="80">
                                <template #default="{data}">
                                    <span v-if="data.is_charge == 1" style="color: darkgray">否</span>
                                    <span v-if="data.is_charge == 2" style="color: green">是</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="确认服务结束时间" width="120">
                                <template #default="{data}">
                                    <span>{{data.confirm_end_date||'-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="补充现场信息" width="150">
                                <template #default="{data}">
                                    <span>{{data.confirm_end_date_remark||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="工单排期" width="180">
                                <template #default="{data}">
                                    <span v-if="data.schedule_start_time && data.schedule_end_time">{{data.schedule_start_time}}~{{data.schedule_end_time}}</span>
                                    <span v-else>-</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="状态" width="120">
                                <template #default="{data}">
                                    <c-state dict="orderMemberStatusDic" :value="data.status"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="出发时间" width="120">
                                <template #default="{data}">
                                    <span>{{data.process_start_date||'-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="到达时间" width="120">
                                <template #default="{data}">
                                    <span>{{data.process_arrival_date||'-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="完工时间" width="120">
                                <template #default="{data}">
                                    <span>{{data.process_end_date||'-'}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="工时" width="120">
                                <template #default="{data}">
                                    <c-link v-if="data.total_work_hours && data.total_work_hours > 0" @click="showUserWorkHoursDetail(data)">{{data.total_work_hours||'-'}}</c-link>
                                    <span v-else>{{data.total_work_hours||'-'}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    v-if="auth('b_aftersale_order_edit') && (detailData.status == 0 || detailData.status == 1||detailData.status == 2)"
                                    type="button"
                                    label="操作"
                                    width="175"
                                    button-limit="3"
                            >
                                <template #default="{data}">
                                    <c-table-button v-if="auth('b_aftersale_order_edit') && (detailData.status == 0 || detailData.status == 1||detailData.status == 2)"
                                                   
                                                    :disabled="data.is_charge == 2"
                                                    icon="tf-remove" @click="removeMember(data)">移除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
                <!--关联单据-->
                <module-tab :name="relatedListTitle" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="relatedListTable" :data="relatedList" border :paging="false">
                            <c-table-column label="单据类型" width="80">
                                <template #default="{data}">
                                    <span v-if="data.work_type == 7">资产领用</span>
                                    <span v-if="data.work_type == 9" style="color: green">外协招工单</span>
                                    <span v-if="data.work_type == 11" style="color: blue">费用报销</span>
                                    <span v-if="data.work_type == 14" style="color: blue">加班申请</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="申请人" width="80">
                                <template #default="{data}">
                                    <c-file v-if="data.head_photo" class="img" :src="data.head_photo" media style="width:30px;height:30px;"></c-file>
                                    <span v-if="data.work_type == 7">{{data.apply_user_name}}</span>
                                    <span v-if="data.work_type == 9">{{data.create_user_realname}}</span>
                                    <span v-if="data.work_type == 11">{{data.create_user_realname}}</span>
                                    <span v-if="data.work_type == 14">{{data.applicant_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="单据编号" width="120">
                                <template #default="{data}">
                                    <span v-if="data.work_type == 7 && !auth('b_asset_receive_view')">{{data.apply_code}}</span>
                                    <c-link v-if="data.work_type == 7 && auth('b_asset_receive_view')" @click="globalDialog('assetReceiveApplyDetail', {props: {id: data.id}})">{{data.apply_code}}</c-link>

                                    <span v-if="data.work_type == 9 && !auth('b_out_sourcing_recruit_query')">{{data.recruit_number}}</span>
                                    <c-link v-if="data.work_type == 9 && auth('b_out_sourcing_recruit_query')" @click="globalDialog('outsourceRrecruitDetail', {props: {id: data.id}})">{{data.recruit_number}}</c-link>

                                    <span v-if="data.work_type == 11 && !auth('b_expense_reimbursement_query')">{{data.document_number}}</span>
                                    <c-link v-if="data.work_type == 11 && auth('b_expense_reimbursement_query')" @click="globalDialog('expenseReimbursementDetail', {props: {id: data.id}})">{{data.document_number}}</c-link>

                                    <span v-if="data.work_type == 14 && !auth('b_overtime_application_view')">{{data.document_number}}</span>
                                    <c-link v-if="data.work_type == 14 && auth('b_overtime_application_view')" @click="globalDialog('overtimeApplicationDetail', {props: {id: data.id}})">{{data.document_number}}</c-link>
                                </template>
                            </c-table-column>

                            <c-table-column label="单据信息" width="120">
                                <template #default="{data}">
                                    <span v-if="data.work_type == 7">
                                        <li>申请数量: {{data.apply_quantity}}</li>
                                    </span>
                                    <span v-if="data.work_type == 9">
                                        <li>招工人数: {{data.recruit_count}}</li>
                                        <li>所需费用: ￥{{data.required_fee}}</li>
                                    </span>
                                    <span v-if="data.work_type == 11">
                                        <li>
                                            报销类型:
                                            <c-state dict="reimbursementTypeDic" :value="data.reimbursement_type"></c-state>
                                        </li>
                                        <li>报销费用: ￥{{data.total_amount}}</li>
                                    </span>
                                    <span v-if="data.work_type == 14">
                                        <li>申请加班时间: <p>{{data.start_date}}~ {{data.end_date}}</p></li>
                                    </span>
                                </template>
                            </c-table-column>

                            <c-table-column label="状态" width="120">
                                <template #default="{data}">
                                    <span v-if="data.work_type == 7">
                                        <c-state dict="applyStatusDic" :value="data.apply_status"></c-state>
                                    </span>
                                    <span v-if="data.work_type == 9">
                                        <c-state dict="applyStatusDic" :value="data.status"></c-state>
                                    </span>
                                    <span v-if="data.work_type == 11">
                                        <c-state dict="applyStatusDic" :value="data.status"></c-state>
                                    </span>
                                    <span v-if="data.work_type == 14">
                                       <c-state dict="applyStatusDic" :value="data.status"></c-state>
                                    </span>


                                </template>
                            </c-table-column>

                            <c-table-column label="创建时间" width="180">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
                <!--工单评价-->
                <module-tab name="工单评价" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="evaluationListTable" :data="evaluationList" border :paging="false">
                            <c-table-column label="评价用户" width="50">
                                <template #default="{data}">
                                    <c-file v-if="data.head_photo" class="img" :src="data.head_photo" media style="width:30px;height:30px;"></c-file>
                                    <span>{{data.create_user_realname}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="评分" width="50">
                                <template #default="{data}">
                                    {{data.service_score}}
                                </template>
                            </c-table-column>

                            <c-table-column label="评价标签" width="100">
                                <template #default="{data}">
                                    {{data.evaluation_tags}}
                                </template>
                            </c-table-column>

                            <c-table-column label="评价图片" width="100">
                                <template #default="{data}">
                                    <c-file-list :value="data.evaluation_images" size="mini"></c-file-list>
                                </template>
                            </c-table-column>

                            <c-table-column label="评价内容" width="300">
                                <template #default="{data}">
                                    {{data.evaluation_content}}
                                </template>
                            </c-table-column>

                            <c-table-column label="评价时间" width="140">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>

        <c-window ref="logDetailwindow" title="详细数据" align="end" height="240">
            <ul class="logs-list">
                <li v-for="(item, i) in logDetailData" :key="i">{{item}}</li>
            </ul>
        </c-window>
    </c-dialog>
</template>

<script>
import logItem from '@/components/public/log_item.vue';
import {mapState} from 'vuex';

export default {
    name: 'afterSaleOrderDetail',

    components: {
        logItem
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            workType: 2,
            detailData: {},
            productList:[],
            memberList:[],
            memberListTitle:'团队成员',
            relatedList:[],
            relatedListTitle:'关联单据',
            logDetailData:[],
            evaluationList:[],
            logTabList: [
                {name: '全部',value: ''},
                {name: '反馈进度',value: '1'},
                {name: '打卡考勤',value: '2'},
                {name: '报工记录',value: '3'},
                {name: '完工记录',value: '4'}
            ]
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['afterSaleOrderStateDic','urgencyLevelDic','evaluateStatusDic',
            'travelModeOptions','useMachineOptions','serviceTypeDic','orderMemberStatusDic','starLevelDic'])
    },

    methods: {
        /**
         * 加载详情
         */
        detail(){
            this.request({
                url: '/after/sale/order/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.memberList = data.memberList||[];
                    this.productList = data.productList||[];
                    this.relatedList = data.relatedList||[];//关联单据
                    this.evaluationList = data.evaluationList||[];//工单评价
                    this.memberListTitle = '团队成员(' + this.memberList.length+')';
                    this.relatedListTitle = '关联单据(' + this.relatedList.length+')';
                    this.$refs.customDetail.init();
                }
            });
            this.$refs.logTab.changeIndex(0);
        },

        open() {
            this.detail();
            this.$refs.dialog.open();
        },

        detailHandle(data) {
            this.logDetailData = data.data_list;
            this.$refs.logDetailwindow.show(this.$refs[`detail${data.id}`]);
        },
        /**
         * 管理参与人
         * @param data
         */
        removeMember(data) {
            this.$confirm({
                message: '是否确定将员工【' + (data.user_realname) + '】移除出成员列表？',
                buttonName: '确定移除',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/after/sale/order/remove_member',
                        data: {
                            order_id:this.id,
                            user_id:data.user_id
                        },
                        success:data => {
                            //刷新详情
                            this.detail();
                            this.$message({
                                message: '移除成功',  // 提示内容,
                                type: 'success'
                            });
                        }
                    });
                },
                cancel: () => {},
            });
        },

        //展示资金明细
        showEstimatedCost() {
            this.globalDialog('estimatedCostDetail', {
                props: {
                    id: this.id
                },
                data: this.detailData
            }, () => {
                // this.$emit('output');
            });
        },

        //展示用户工时明细
        showUserWorkHoursDetail(data) {
            console.log(data)
            this.globalDialog('orderWorkhoursDetail', {
                props: {
                    id: this.id
                },
                data: data
            }, () => {
                // this.$emit('output');
            });
        },
        //加载工单记录
        logTabHandle(tab) {
            this.$refs.logList.load({
                url: '/after/sale/order/log/list',
                data: {
                    order_id: this.id,
                    log_type: tab.value
                },
                dataFormatter: data => {
                    data.forEach(item => {
                        if (!item.data_json) return;
                        item.data_list = [];

                        if (item.report_list) {
                            item.report_list.forEach(person => {
                                person.product_list.forEach(product => {
                                    item.data_list.push({
                                        //operation_type 23:报工;30:完工
                                        content: `${person.user_name} | ${product.product_code}  ${product.inventory_name || ''} | 长：${product.length || '-'}mm 宽：${product.width || '-'}mm | `+(item.operation_type==30?`完工总数`:`报工数`)+`：${product.pieces} | 工时：${product.work_hours}小时`
                                    });
                                });
                            });
                        }

                        if (item.operation_type == 2) {
                            item.data_json.forEach(field => {
                                item.data_list.push({
                                    content: `【${field.字段}】: 【${field.原值 || '空'}】 → 【${field.新值 || '空'}】`
                                });
                            });
                        } else {
                            item.data_json.forEach(field => {
                                let key = Object.keys(field)[0];
                                item.data_list.push({
                                    label: key,
                                    content: field[key]
                                });
                            });
                        }
                    });
                    return data;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>